export default __webpack_public_path__ + "static/media/bt_ingresa.dcdb17ea.png";